import { useState } from 'react'
import { customerData, CustomerInvoiceData } from '../../utilities/CustomerData'
import { apiURL } from '../../utilities/URLs'
import DashboardTOSModal from '../Dashboard/DashboardScreens/DashboardTOS/DashboardTOS'
import { useNavigate } from 'react-router-dom'
import { GenerateInvoicePostPaid, GenerateInvoicePrePaid } from './PaymentModals'
import { refreshAccessToken } from '../../utilities/extensions'
import posthog from 'posthog-js'

export function RefundCalculatedWindow() {
  const navigate = useNavigate()

  const [showTOS, setShowTOS] = useState(false)
  const [customerStageTreeIndex, setCustomerStageTreeIndex] = useState(customerData.customerStageHistory.find(stage => stage.currentStage === true).customerStageTreeIndex)
  const [generatingInvoice, setGeneratingInvoice] = useState(false)
  const [showPostPaidInvoice, setShowPostPaidInvoice] = useState(false)
  const [showPrePaidInvoice, setShowPrePaidInvoice] = useState(false)
  const [tosCustomerFee, setTOSCustomerFee] = useState(0.15)
  const [tosOptionClicked, setTOSOptionClicked] = useState(0)

  const handledSignedAndSetFee = async () => {
    await handleSignedTOS(tosCustomerFee, tosOptionClicked)
  }

  const handleShowInvoiceModal = () => {
    navigate('/refundCalculated')
  }

  const handleSignedTOS = async (customerFee, optionClicked) => {
    setShowTOS(false)
    setGeneratingInvoice(true)

    const formData = new FormData()
    formData.append('customerInvoiceInfo', JSON.stringify({
      zohoId: customerData.customerLeadData.leadId,
      customerId: customerData.customerLeadData.leadContact.contactId,
      invoiceId: customerData.customerInvoiceData.invoiceId,
      customerName: customerData.customerLeadData.leadContact.contactName,
      customerEmail: customerData.customerLeadData.leadContact.contactEmail,
      customerRefundAmount: customerData.customerLeadData.leadAmount,
      customerFee: customerFee,
      invoicePaymentType: optionClicked === 1 ? 'Post-Paid' : 'Pre-Paid',
      currentInvoiceLink: customerData.customerInvoiceData.invoiceLinkURL
    }))

    const generateInvoiceResponse = await fetch(`${apiURL}/api/generateInvoice`, {
      method: 'POST',
      body: formData,
      headers: {
        'Authorization': customerData.accessToken
      }
    })
    const generateInvoiceData = await generateInvoiceResponse.json()
    setGeneratingInvoice(false)

    if (generateInvoiceData.response.error) {
      if (generateInvoiceData.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleSignedTOS(customerFee, optionClicked) : navigate('/', { state: { expired: true } })
      } else
        console.error(generateInvoiceData.response.error)
    } else {
      posthog.stopSessionRecording()
      customerData.customerInvoiceData = new CustomerInvoiceData(generateInvoiceData.response.invoiceData.invoiceInfo)

      if (customerData.customerLeadData.leadId === '6023320000030939004')
        navigate('/shippoRates', { state: { isPostPaid: optionClicked === 1 ? true : false } })
      else
        navigate(optionClicked === 1 ? '/addPaymentMethod' : '/paymentPortal')
    }
  }

  return (
    <>
      <div className='shadow-md p-6 rounded-xl lg:w-full w-11/12 h-fit flex flex-col bg-[#5186C0] font-robo text-white'>
        <div className='w-full flex flex-col items-center'>
          <div className='flex flex-col items-center gap-4 mt-4'>
            <button 
              onClick={handleShowInvoiceModal} 
              className='w-full p-4 bg-[#FF8C00] hover:bg-[#E67E00] transition duration-200 rounded-lg text-3xl font-bold shadow-md'>
                <div className='flex flex-col items-center gap-2'>
                  <p>Get My Refund <span className='underline'>NOW!</span></p>
                  <p className='text-lg'>Click Here</p>
                </div>
            </button>
            <div className='bg-white p-4 rounded-md shadow-md w-full'>
              <iframe className='w-full aspect-video' src="https://fast.wistia.net/embed/iframe/23s5nkvvis?web_component=true&seo=true" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <p className='text-gray-300 text-sm italic'>*Net tax credit amount must be $3,000 or greater to be eligible. Applicants in Iowa, Colorado, and U.S. Territories are not eligible for the Express Refund option.</p>
          </div>
        </div>
      </div>
      <GenerateInvoicePostPaid
        isOpen={showPostPaidInvoice}
        setIsOpen={setShowPostPaidInvoice}
        setShowTOS={setShowTOS}
        handleSignedTOS={handleSignedTOS}
        setTOSCustomerFee={setTOSCustomerFee}
        setTOSOptionClicked={setTOSOptionClicked}
        generatingInvoice={generatingInvoice}
      />
      <GenerateInvoicePrePaid
        isOpen={showPrePaidInvoice}
        setIsOpen={setShowPrePaidInvoice}
        setShowTOS={setShowTOS}
        handleSignedTOS={handleSignedTOS}
        setTOSCustomerFee={setTOSCustomerFee}
        setTOSOptionClicked={setTOSOptionClicked}
        generatingInvoice={generatingInvoice}
      />
      <DashboardTOSModal
        isOpen={showTOS}
        setIsOpen={setShowTOS}
        onClose={handledSignedAndSetFee}
      />
    </>
  )
}